<template>
  <section class="integration-payload">
    <header>
      <h3>{{ title }}</h3>
      <CopyButton v-if="available" :value="formatted" :label="title" />
    </header>
    <p
      v-if="originLabel || (payload && (payload.capture_scope || payload.content_type || payload.redacted))"
      class="integration-muted"
    >
      {{ originLabel || humanize(payload && payload.capture_scope) }}
      <template v-if="payload && payload.content_type">· {{ payload.content_type }}</template>
      <strong v-if="payload && payload.redacted">· Redacted</strong>
    </p>
    <p v-if="!available" role="status">
      {{ title }}: {{ humanize((payload && payload.availability) || 'not_recorded') }}
      <template v-if="payload && payload.reason">— {{ payload.reason }}</template>
    </p>
    <div v-else class="integration-payload__body">
      <pre>{{ formatted }}<span v-if="formatted === ''" class="integration-muted">Empty text (recorded)</span></pre>
    </div>
  </section>
</template>

<script>
import CopyButton from './CopyButton'
import { humanize } from './model'
export default {
  components: { CopyButton },
  props: { title: { type: String, required: true }, payload: Object, originLabel: String },
  computed: {
    available() { return this.payload?.availability === 'available' },
    formatted() { return this.available ? this.payload.format === 'json' ? JSON.stringify(this.payload.value, null, 2) : String(this.payload.value ?? '') : '' }
  },
  methods: { humanize }
}
</script>
<style scoped lang="scss">
.integration-payload { min-width: 0; padding: 13px 14px; border: 1px solid $ui-line; border-radius: 7px; background: $ui-surface; box-shadow: 0 2px 8px rgba(31, 49, 52, .05); }
.integration-payload header { display: flex; min-height: 36px; align-items: center; justify-content: space-between; gap: $ui-space-8; margin-bottom: 10px; padding-bottom: 7px; border-bottom: 1px solid $ui-line; }
.integration-payload h3 { margin: 0; font: 600 16px/20px $ui-font-heading; color: $ui-ink; }
.integration-payload p { margin: $ui-space-8 0; overflow-wrap: anywhere; }
.integration-payload__body { padding: $ui-space-12; border: 1px solid $ui-line; border-radius: $ui-control-radius; background: $ui-surface-soft; }
.integration-payload pre { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; font: 12px/1.7 monospace; }
</style>
